import { UrlFilterController } from 'app/components/filters/url-filters';
import { TaskTypeAdapter } from 'app/components/filters/task-type-filter';
import { AUTH_TOKEN } from 'app/constants';
import { HttpError } from 'app/components/utils/http-error';
import { EventsHistogram } from 'app/console-api/statistics/types';
import { AppsFilterAdapter } from 'app/components/filters/apps-filter';
import { GroupByFilterAdapter } from 'app/components/filters/group-by-filter';
import { DateRangeFilterAdapter } from 'app/components/filters/date-range-filter';
import { EventTypeFilterAdapter } from 'app/components/filters/event-type-filter';
import { TaskListFilterAdapter } from 'app/components/filters/task-list-filter';
import { OfferListFilterAdapter } from 'app/components/filters/offer-list-filter';
import { DealsListFilterAdapter } from 'app/components/filters/deals-list-filter';
import { EventOriginFilterAdapter } from 'app/components/filters/event-origin-filter';
import { PeriodFilterAdapter } from 'app/components/filters/period-filter';

export const getEventsHistogram = async (
  ctl: UrlFilterController,
  appID?: string
): Promise<EventsHistogram> => {
  const searchParams = ctl.buildSearchParams([
    { adapter: DateRangeFilterAdapter, value: ctl.get(DateRangeFilterAdapter) },
    { adapter: EventOriginFilterAdapter, value: ctl.get(EventOriginFilterAdapter) },
    { adapter: GroupByFilterAdapter, value: ctl.get(GroupByFilterAdapter) },
    { adapter: PeriodFilterAdapter, value: ctl.get(PeriodFilterAdapter) },
    { adapter: AppsFilterAdapter, value: ctl.get(AppsFilterAdapter) },
    { adapter: EventTypeFilterAdapter, value: ctl.get(EventTypeFilterAdapter) },
    { adapter: TaskTypeAdapter, value: ctl.get(TaskTypeAdapter) },
    { adapter: TaskListFilterAdapter, value: ctl.get(TaskListFilterAdapter) },
    { adapter: OfferListFilterAdapter, value: ctl.get(OfferListFilterAdapter) },
    { adapter: DealsListFilterAdapter, value: ctl.get(DealsListFilterAdapter) }
  ]);
  if (appID) {
    searchParams.append('apps', appID);
  }
  const response = await fetch(
    `${process.env.REACT_APP_TRAFFIC_EXCHANGE_CONSOLE_API_URL}/analytics/events?${searchParams.toString()}`,
    {
      headers: {
        Authorization: `Bearer ${localStorage.getItem(AUTH_TOKEN) || ''}`
      }
    }
  );
  if (!response.ok) {
    return Promise.reject(
      new HttpError(`Failed to get events histogram: ${response.statusText}`, response.status)
    );
  }
  return await response.json();
};
